import {
  Box,
  Button,
  Grid,
  IconButton,
  Tooltip,
  Typography,
  TextField,
  MenuItem,
  Select,
  FormControl,
} from "@mui/material";
import React, { useState } from "react";
import { WSIcons } from "../../commonFunctions/iIcons";
import WSDateField from "../../Components/DateField/WSDateField";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import WSDataGrid, { IColumns } from "../../Components/DataGrid/WSDataGrid";
import WSTextField from "../../Components/TextBox/WSTextBox";
import WSSelectField from "../../Components/Select/WSSelect";

export const CallCenterOrderList: React.FC<any> = React.memo((props) => {
  const { register, control } = useForm();
  const navigate = useNavigate();

  const [showDropdown, setShowDropdown] = useState(false);
  const [driverButton, setDriverButton] = useState("Driver Out");
  const [selectedIcon, setSelectedIcon] = useState<string | null>(null);

  const handleClick = (path: string) => {
    navigate(path);
  };

  const handleFirstIconClick = () => {
    setSelectedIcon("allOrder");
    setShowDropdown(false);
    setDriverButton("");
  };

  const handleSecondIconClick = () => {
    setSelectedIcon("deliveryOrder");
    setShowDropdown(true);
    setDriverButton("Driver Out");
  };

  const handleThirdIconClick = () => {
    setSelectedIcon("outOrder");
    setShowDropdown(true);
    setDriverButton("Driver In");
  };

  const columns: IColumns[] = [
    {
      header: "Receipt#",
      fieldName: "workLocationName",
      tooltip: true,
    },
    {
      header: "Table/User",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Item Name",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Order Time",
      fieldName: "address",
      tooltip: true,
    },
    {
      header: "Deliver Time",
      fieldName: "address",
      tooltip: true,
    },
  ];

  return (
    <Grid display="flex" flexDirection="column" minHeight="100vh">
      <Grid container direction="column" spacing={2} p={2} flex="1">
        {/* Header and Icon Section */}
        <Grid item>
          <Grid container alignItems="center" justifyContent="space-between">
            <Grid item>
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: "green" }}
              >
                Call Center Order List
              </Typography>
            </Grid>
            <Grid item>
              <Grid display="flex" alignItems="center">
                <Tooltip title="All Order">
                  <IconButton
                    sx={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      marginRight: "8px",
                      borderRadius: "2px",
                      backgroundColor:
                        selectedIcon === "allOrder" ? "green" : "transparent",
                      color: selectedIcon === "allOrder" ? "white" : "inherit",
                    }}
                    onClick={handleFirstIconClick}
                  >
                    <WSIcons.ReceiptIcon />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Delivery Order">
                  <IconButton
                    sx={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      marginRight: "8px",
                      borderRadius: "2px",
                      backgroundColor:
                        selectedIcon === "deliveryOrder"
                          ? "green"
                          : "transparent",
                      color:
                        selectedIcon === "deliveryOrder" ? "white" : "inherit",
                    }}
                    onClick={handleSecondIconClick}
                  >
                    <WSIcons.DeliveryDiningIcon />
                  </IconButton>
                </Tooltip>

                <Tooltip title="Out Order">
                  <IconButton
                    sx={{
                      border: "1px solid #ccc",
                      padding: "8px",
                      marginRight: "8px",
                      borderRadius: "2px",
                      backgroundColor:
                        selectedIcon === "outOrder" ? "green" : "transparent",
                      color: selectedIcon === "outOrder" ? "white" : "inherit",
                    }}
                    onClick={handleThirdIconClick}
                  >
                    <WSIcons.DeliveryDiningIcon />
                  </IconButton>
                </Tooltip>

                <WSDateField
                  id="date"
                  name="date"
                  dateFormat="D/MM/YYYY"
                  control={control}
                  defaultValue={null}
                  rules={{ required: true }}
                  label={""}
                />
                <IconButton>
                  <WSIcons.CloseIcon
                    sx={{ backgroundColor: "red", color: "white" }}
                    onClick={() => handleClick("/")}
                  />
                </IconButton>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Content Section */}
        <Grid item>
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Grid
                sx={{
                  border: "1px solid #ccc",
                  padding: 2,
                  borderRadius: 2,
                  height: "30rem",
                }}
              >
                {/* Left Box Content */}
              </Grid>
            </Grid>
            <Grid item xs={6}>
              <Grid
                sx={{
                  border: "1px solid #ccc",
                  padding: 2,
                  borderRadius: 2,
                  height: "30rem",
                }}
              >
                {/* Right Box Content */}
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        {/* Dropdown and Amount Field in Same Line */}
        <Grid item container justifyContent="space-between" alignItems="center">
          <Grid item xs={4}>
            {showDropdown && (
              <WSSelectField
                rules={{ required: true }}
                {...register("driver")}
                id="driver"
                control={control}
                defaultValue={"0"}
                label="Driver"
                name="driver"
                labelType="Normal"
              />
            )}
          </Grid>
          <Grid item xs={4}>
            <WSTextField
              label={"Amount"}
              {...register("amount")}
              id="amount"
              name="amount"
              control={control}
              rules={{ required: true }}
              labelType="Normal"
            />
          </Grid>
        </Grid>
      </Grid>

      {/* Footer Section */}
      <Grid
        bgcolor="#333"
        p={2}
        display="flex"
        alignItems="center"
        justifyContent="space-between"
      >
        <WSIcons.GTranslateIcon />

        {/* Button Group aligned to the right with spacing */}
        <Grid display="flex" gap={1} sx={{ marginLeft: "auto" }}>
          <Button
            variant="outlined"
            sx={{ borderColor: "green", color: "white" }}
          >
            Void
          </Button>
          <Button
            variant="outlined"
            sx={{ borderColor: "green", color: "white" }}
          >
            Reprint
          </Button>
          <Button
            variant="outlined"
            sx={{ borderColor: "green", color: "white" }}
          >
            Settle
          </Button>
          <Button
            variant="outlined"
            sx={{ borderColor: "green", color: "white" }}
          >
            Recall
          </Button>
          <Button
            variant="outlined"
            sx={{ borderColor: "green", color: "white" }}
            onClick={() => handleClick("/exportedorder")}
          >
            Import Order
          </Button>
          {driverButton && (
            <Button variant="contained" color="success">
              {driverButton}
            </Button>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
});
